// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__34w5u","detailsBorder":"styles_detailsBorder__3dcsb"};